import * as createjs from 'createjs-module';
// import { Tree } from './Tree';

export let attributes = [
  'x',
  'y',
  'scaleX',
  'scaleY',
  'skewX',
  'skewY',
  'rotation',
  'alpha'
];

export let displayTypes = [
  'SHAPE_MOVIE_CLIP',
  'LINE'
];

export function createStage(canvas) {
  const stage = new createjs.Stage(canvas);
  stage.enableMouseOver();
  // Registers the "tick" event listener.
  // createjs.Ticker.setFPS(24);
  createjs.Ticker.framerate = 30;
  createjs.Ticker.addEventListener('tick', () => {
    // console.log('tick', this.stage);
    stage.update();
  });
  return stage;
}

/**
 * @param {Tree} tree
 */
export function renderTree({ tree, canvas, stage, handlers, tweenItems = [] }) {
  const queue = [tree.root];
  stage = stage ? stage : createStage(canvas);
  const children = stage.children.slice(0);
  children.forEach(child => {
    stage.removeChild(child);
  });
  const tweenIds  = tweenItems.map(t => t.id);
  // stage.removeAllChildren();
  // tree.setStage(stage);
  /**
   * @type {Node}
   */
  let current = tree.root;
  let parent;
  let parentId;
  let parentDisplayObject;
  let currentDisplayObject;
  let node;
  current.setDisplayObject(stage);
  while (queue.length) {
    current = queue.shift();
    parentId = current.parentId;
    parent = tree.get(parentId);
    if (parent) {
      /*
       * Do not create a new displayObject if:
       *   there is a displayObject and the id is in tweenIds
       * Create a new display object if
       * 1. it does not exist
       * or
       * 2. it is not in the tweenIds
       */
      currentDisplayObject = current.getDisplayObject();
      if (!currentDisplayObject || !tweenIds.includes(current.id)) {
        currentDisplayObject = createFromNode(current);
        parentDisplayObject = parent.getDisplayObject();
        parentDisplayObject.addChild(currentDisplayObject);
        current.setDisplayObject(currentDisplayObject);
      }
    }
    current.children.forEach(child => {
      queue.push(child);
    });
  }
  // children.forEach(child => {
  //   stage.removeChild(child);
  // });
  if (Array.isArray(handlers)) {
    handlers.forEach(handler => {
      node = tree.get(handler.id);
      if (node.displayObject) {
        const { action, callback } = handler;
        node.displayObject.on(action, callback.bind(node));
      }
    });
  }
  tree.setStage(stage);
}

export function updateValueFromDisplayObject({ tree, id }){
  const node = tree.get(id);
  if (node && node.displayObject) {
    const value = node.value;
    value.attrs = value.attrs instanceof Object ? value.attrs : {};
    const obj = node.displayObject;
    attributes.forEach(a => {
      value.attrs[a] = obj[a];
    });
    value.bounds = value.bounds instanceof Object ? value.bounds : {};
    const bounds = value.bounds;
    const nb = obj.nominalBounds;
    if (nb) {
      ['x', 'y', 'width', 'height'].forEach(a => {
        bounds[a] = nb[a];
      });
    }
  }
}

function createFromNode(node) {
  if (!node) {
    return null;
  }
  const value = node.value;
  let displayObject = null;
  switch (value.type) {
    case 'SHAPE_MOVIE_CLIP':
      displayObject = createShapeMovieClip(value);
      break;
    case 'LINE':
      displayObject = createLineShape(value);
      break;
    default:
      break;
  }
  if (displayObject) {
    displayObject.id = node.id;
  }
  return displayObject;
}

export let addText = ({ text, movieClip, options }) => {
  let margin = options.margin || { left: 0, right: 0, top: 0, bottom: 0 };
  let padding = options.padding || { left: 0, right: 0, top: 0, bottom: 0 };
  let fontFamily = options.fontFamily || 'Arial';
  let fontSize = options.fontSize || 24;
  let fontStyle = options.fontStyle || '';
  let font = `${fontStyle} ${fontSize}px ${fontFamily}`;
  let textAlign = options.textAlign || 'center';
  const innerWidth = options.width - margin.left - margin.right;
  let textObj = new createjs.Text()
    .set({
      text,
      font,
      color: options.color || '#000',
      lineWidth: innerWidth - margin.left - margin.right - padding.left - padding.right
    });
  textObj.alpha = options.alpha || '1';
  textObj.textAlign = textAlign;
  let bounds = options.bounds || textObj.getBounds();
  let xOffset = textAlign === 'center' ? bounds.width / 2 : 0;
  textObj.x = margin.left + padding.left + xOffset;
  textObj.y = margin.top + padding.top;
  movieClip.addChild(textObj);
  return textObj;
};

export let loadImages = (imageArray) => {
  // console.log(imageArray)
  return new Promise((resolve, reject) => {
    const queue = new createjs.LoadQueue();
    queue.on('error', () => { reject (new Error('loadImages error')); });
    queue.on('complete', () => { resolve(queue); });
    const manifest = imageArray.map((src, i) => ({ id: i + 1, src }));
    // console.log(manifest)
    queue.loadManifest(manifest);
  });
};

export let createShapeMovieClip = ({ bounds, attrs } ) => {
  const shape = new createjs.Shape();
  attrs = attrs instanceof Object ? attrs : {};
  attrs.scaleX = typeof attrs.scaleX === 'number' ? attrs.scaleX : 1;
  attrs.scaleY = typeof attrs.scaleY === 'number' ? attrs.scaleY : 1;
  attrs.skewX = typeof attrs.skewX === 'number' ? attrs.skewX : 0;
  attrs.skewY = typeof attrs.skewY === 'number' ? attrs.skewY : 0;
  attrs.rotation = typeof attrs.rotation === 'number' ? attrs.rotation : 0;
  attrs.color = attrs.color || '#00FF00';
  attrs.alpha = typeof attrs.alpha === 'number' ? attrs.alpha : 1;
  shape
    .graphics
    .beginFill(attrs.color)
    .drawRect(bounds.x, bounds.y, bounds.width, bounds.height);
  shape._off = true;
  shape.alpha = attrs.alpha;
  const movieClip = new createjs.MovieClip();
  ['x', 'y', 'scaleX', 'scaleY', 'skewX', 'skewY', 'rotation'].forEach(a => {
    movieClip[a] = attrs[a];
  });
  movieClip.addChild(shape);
  movieClip.nominalBounds = Object.assign({},  bounds);
  addHitArea({ movieClip });
  const hitArea = movieClip.hitArea;
  movieClip.enableHitArea = () => {
    movieClip.hitArea = hitArea;
  }
  movieClip.disableHitArea = () => {
    movieClip.hitArea = null;
  }
  if (attrs.hitArea === false) {
    movieClip.disableHitArea();
  }
  return movieClip;
};

export let createBackgroundMovieClip = ({ stage, color, alpha }) => {
  const bounds = {
    x: 0,
    y: 0,
    width: stage.canvas.width,
    height: stage.canvas.height
  };
  return createShapeMovieClip( { bounds, color, alpha });
};

export let createButton = ({ text, bounds }) => {
  const buttonBounds = { x: 0, y: 0, width: bounds.width, height: 60 };
  const color = '#EEC900';
  // const hoverColor = changeShade({ color, fraction: 0.3 })
  const hoverColor = '#FFD700';
  // console.log('colors: ', color, hoverColor)
  const textMovieClip = createShapeMovieClip( {
    bounds: buttonBounds,
    color,
    alpha: 1
  });
  const shape = textMovieClip.children[0];
  textMovieClip.on('mouseover', () => {
    changeShapeColor({ shape, color: hoverColor });
  });
  textMovieClip.on('mouseout', () => {
    changeShapeColor({ shape, color });
  });
  addTextToMovieClip({
    mc: textMovieClip,
    frames: [
      {
        text,
        fontSize: 18,
        fontAlpha: 1,
        fontColor: '#000',
        textAlign: 'center',
        padding: {
          top: 10,
          left: 0,
          right: 0,
          bottom: 0
        }
      }
    ],
    width: bounds.width,
    padding: {
      top: 10,
      left: 0,
      right: 0,
      bottom: 10
    },
    margin: {
      top: 10,
      left:0,
      right: 0,
      bottom: 10
    }
  });
  textMovieClip.setText = (newText) => {
    textMovieClip.frames[0].textObj.text = newText;
  };
  return textMovieClip;
};

/**
 * @function addHitArea
 * @summary
 * Use this function to set the hitArea of a movie clip.
 * @description
 * If you add a mouse/touch event to a movie clip, it requires that the hitArea be set for it to fire.
 *
 * Note: the nominal bounds of a movie clip is the area encompassing all the displayObjects (shapes, bitmaps, etc)
 * added to the movie clip using the GUI (i.e. does not include programmatically added displayObjects).
 * Animate CC automatically calculates the encompassing area and adds it to the movie clip object when the project
 * is published.
 *
 * @param {Object} options
 * @param {createjs.MovieClip} options.movieClip
 */
export function addHitArea (options) {
  const MC = options.movieClip;
  if (!(MC instanceof window.createjs.MovieClip)) {
    console.error('addHitArea must be called with options.movieClip');
    return;
  }
  /*
   * Only movie clips created with the Animate CC App have a nominalBounds object
   */
  if (!MC.nominalBounds) {
    MC.nominalBounds = MC.getBounds();
  }
  /*
   * The hit area scales with the movie clip automatically
   */
  const width = MC.nominalBounds.width;
  const height = MC.nominalBounds.height;
  const x = MC.nominalBounds.x;
  const y = MC.nominalBounds.y;
  MC.hitArea = new window.createjs.Shape();
  MC.hitArea
    .graphics
    .beginFill('#000')
    .drawRect(x, y, width, height);
}

/**
 * @function changeShapeColor
 * @summary
 * Change the color of an existing shape.
 *
 * @param {Object} options
 * @param {createjs.Shape} options.shape
 * @param {string} options.color HexColor string (ex. '#FF0000') or WebColor (ex. 'teal')
 */
export function changeShapeColor (options) {
  const msg = 'Must call changeShapeColor with options.shape and options.color';
  if ((typeof options !== 'object') || !options.shape || !options.color) {
    console.error(msg);
    return;
  }
  const shape = options.shape;
  if (!(shape instanceof window.createjs.Shape)) {
    console.error(msg);
    return;
  }
  const fillCommands = shape.graphics.instructions.filter(
    inst => {
      return inst instanceof window.createjs.Graphics.Fill;
    }
  );
  fillCommands.forEach((cmd) => {
    cmd.style = options.color;
  });
}

export function addTextToMovieClip (options) {
  const frames = options.frames;
  const mc = options.mc;
  const defaultMargin = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };
  const sides = ['top', 'left', 'right', 'bottom'];
  let margin = {};
  if (options.margin instanceof Object) {
    sides.forEach((side) => {
      if (isNumber(options.margin[side])) {
        margin[side] = options.margin[side];
      }
    });
  }
  margin = Object.assign({}, defaultMargin, margin);
  mc.frames = [];
  let y = margin.top;
  const x0 = margin.left;
  const innerWidth = options.width - margin.left - margin.right;
  const lastLineHeight = 0;

  frames.forEach((frame) => {
    if (typeof frame !== 'object') {
      console.error('each frame must be an object');
    } else {
      frame.text = typeof frame.text === 'string' ? frame.text : '';
      if (frame.text) {
        const textOptions = getTextOptions(frame);
        const font = textOptions.font;
        let lineHeight = textOptions.lineHeight;
        // let lastLineHeight = lineHeight;
        const textAlign = textOptions.textAlign;
        const fontColor = textOptions.fontColor;
        const fontAlpha = textOptions.fontAlpha;
        const backgroundColor = textOptions.backgroundColor;
        const backgroundAlpha = textOptions.backgroundAlpha;
        const padding = textOptions.padding;
        const margin = textOptions.margin;
        const textObj = new createjs.Text()
          .set({
            text: frame.text,
            font: font,
            color: fontColor,
            lineWidth: innerWidth - margin.left - margin.right - padding.left - padding.right
          });
        textObj.textAlign = textAlign;
        textObj.alpha = fontAlpha;
        textObj.lineHeight = lineHeight;
        const xOffset = textAlign === 'center' ? options.width / 2 : 0;
        textObj.x = x0 + margin.left + padding.left + xOffset;
        textObj.y = y + margin.top + padding.top;
        const textBounds = textObj.getBounds();
        const shapeBounds = {
          x: textObj.x - padding.left,
          y: textObj.y - padding.top,
          width: textBounds.width + padding.left + padding.right,
          height: textBounds.height + padding.top + padding.bottom
        };
        const shape = new createjs.Shape();
        shape
          .graphics
          .beginFill(backgroundColor)
          .drawRect(shapeBounds.x, shapeBounds.y, shapeBounds.width, shapeBounds.height);
        shape.alpha = backgroundAlpha;
        mc.addChild(shape);
        mc.addChild(textObj);
        mc.frames.push({
          textObj: textObj,
          shape: shape
        });
        y += textBounds.height + margin.top + margin.bottom + padding.top + padding.bottom;
      }
    }
  });
  const bounds = mc.getBounds();
  mc.nominalBounds = {
    x: 0,
    y: 0,
    width: options.width,
    height: bounds.height + margin.top + margin.bottom + lastLineHeight
  };
}

function getTextOptions (options) {
  const defaultFontSize = 24;
  const defaultFontWeight = 'bold';
  const defaultFontFamily = 'Arial';
  const defaultLineFactor = 1.25;
  const defaultFontColor = '#333';
  const defaultFontAlpha = 0.8;
  const defaultBackgroundColor = '#CCC';
  const defaultBackgroundAlpha = 0;
  const defaultMargin = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };
  const defaultPadding = {
    top: 10,
    left: 10,
    right: 10,
    bottom: 10
  };
  const sides = ['top', 'left', 'right', 'bottom'];
  let margin = {};
  if (options.margin instanceof Object) {
    sides.forEach( (side) => {
      if (isNumber(options.margin[side])) {
        margin[side] = options.margin[side];
      }
    });
  }
  margin = Object.assign({}, defaultMargin, margin);
  let padding = {};
  if (options.padding instanceof Object) {
    sides.forEach((side) => {
      if (isNumberNonNegative(options.padding[side])) {
        padding[side] = options.padding[side];
      }
    });
  }
  padding = Object.assign({}, defaultPadding, padding);
  /*
   * Set font & shape options
   */
  const fontSize = isNumber(options.fontSize) ? options.fontSize : defaultFontSize;
  let fontWeight;
  if (!options.fontWeight) {
    fontWeight = defaultFontWeight;
  } else if (isNumber(options.fontWeight)) {
    if ([100, 200, 300, 400, 500, 600, 700, 800, 900].includes(options.fontWeight)) {
      fontWeight = options.fontWeight;
    } else {
      console.error('Numeric allowable font weigths are 100, 200, ... 900');
      fontWeight = defaultFontWeight;
    }
  } else if (['normal', 'bold', 'bolder', 'lighter'].includes(options.fontWeight)) {
    fontWeight = options.fontWeight;
  } else {
    console.error('Named allowable font weights are normal, bold, bolder, or lighter');
    fontWeight = defaultFontWeight;
  }
  let fontFamily = defaultFontFamily;
  if (options.fontFamily) {
    const fonts = [
      'Arial',
      'Arial Black',
      'Helvetica',
      'Times New Roman',
      'Times',
      'Courier New',
      'Courier',
      'Verdana',
      'Georgia',
      'Palatino',
      'Garamond',
      'Bookman',
      'Comic Sans MS',
      'Trebuchet MS',
      'Impact'
    ];
    if (!fonts.includes(options.fontFamily)) {
      console.error('Font Family must be one of ' + fonts.join(', '));
    } else {
      fontFamily = options.fontFamily;
    }
  }
  let fontStyle = 'normal';
  const fontStyles = ['normal', 'italic', 'oblique'];
  if (options.fontStyle) {
    if (fontStyles.includes(options.fontStyle)) {
      fontStyle = options.fontStyle;
    } else {
      console.error('font style must be one of ' + fontStyles.join(', '));
    }
  }
  const lineHeight = isNumber(options.lineFactor)
    ? options.lineFactor * fontSize : defaultLineFactor * fontSize;
  // y += lineHeight
  let textAlign = 'left';
  const textAligns = ['left', 'right', 'start', 'end', 'center'];
  if (!options.textAlign) {
    textAlign = 'left';
  } else if (textAligns.includes(options.textAlign)) {
    textAlign = options.textAlign;
  } else {
    console.error('textAlign must be one of ' + textAligns.join(', '));
  }
  const fontColor = options.fontColor || defaultFontColor;
  const fontAlpha = isNumber(options.fontAlpha) ? options.fontAlpha : defaultFontAlpha;
  const backgroundColor = options.backgroundColor || defaultBackgroundColor;
  const backgroundAlpha = isNumber(options.backgroundAlpha) ? options.backgroundAlpha : defaultBackgroundAlpha;
  const font = fontStyle + ' ' + fontWeight + ' ' + fontSize + 'px ' + fontFamily;
  return ({
    font: font,
    lineHeight: lineHeight,
    textAlign: textAlign,
    fontColor: fontColor,
    fontAlpha: fontAlpha,
    backgroundColor: backgroundColor,
    backgroundAlpha: backgroundAlpha,
    margin: margin,
    padding: padding
  });
}

function isNumber (x) {
  return typeof x === 'number';
}

function isNumberNonNegative (x) {
  return isNumber(x) && x >= 0;
}

export function getBounds({x, y, width, height}) {
  return {
    x, y, width, height
  };
}

export class StrokeStyle {
  /*
  setStrokeStyle ( thickness  [caps=0]  [joints=0]  [miterLimit=10]  [ignoreScale=false] ) Graphics chainable

  Sets the stroke style. Like all drawing methods, this can be chained, so you can define the stroke style and color in a single line of code like so:

  myGraphics.setStrokeStyle(8,"round").beginStroke("#F00");
  A tiny API method "ss" also exists.

  Parameters:
  thickness Number
  The width of the stroke.
  [caps=0] String | Number optional
  Indicates the type of caps to use at the end of lines. One of butt, round, or square. Defaults to "butt". Also accepts the values 0 (butt), 1 (round), and 2 (square) for use with the tiny API.
  [joints=0] String | Number optional
  Specifies the type of joints that should be used where two lines meet. One of bevel, round, or miter. Defaults to "miter". Also accepts the values 0 (miter), 1 (round), and 2 (bevel) for use with the tiny API.
  [miterLimit=10] Number optional
  If joints is set to "miter", then you can specify a miter limit ratio which controls at what point a mitered joint will be clipped.
  [ignoreScale=false] Boolean optional
  If true, the stroke will be drawn at the specified thickness regardless of active transformations.
   */
  constructor({
    thickness = 1,
    caps = 'butt',
    joints = 'miter',
    miterLimit = 10,
    ignoreScale = false
  } = {}) {
    if (isNaN(Number(thickness))) {
      thickness = 1;
    }
    if (!['butt', 'round', 'square'].includes(caps)) {
      throw new Error('StokeStyle constructor invalid caps: ${caps}');
    }
    if (!['bevel', 'round', 'miter'].includes(joints)) {
      throw new Error('StokeStyle constructor invalid joints: ${joints}');
    }
    ignoreScale = ignoreScale === true;
    Object.assign(this, {thickness, caps, joints, miterLimit, ignoreScale});
  }

  toArray() {
    /*
     * TODO: Add miterLimit
     */
    return [this.thickness, this.caps, this.joints, this.ignoreScale];
  }
}

/**
 * @type RegExp
 */
const colorRE = /#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})/;

export function createLineShape(
  {
    color = '#000',
    strokeStyle,
    x0,
    y0,
    x1,
    y1

  }) {
  // if (typeof color !== 'string' || (!(color.length !== 4) || !(color.length !== 7)) || color[0] !== '#') {
  if (!colorRE.test(color)) {
    throw new Error(`createLineShape invalid color ${color}`);
  }
  if (!(strokeStyle instanceof StrokeStyle)) {
    console.warn('createLineShape: using default strokeStyle');
    strokeStyle = new StrokeStyle();
  }
  if (isNaN(Number(x0))) {
    throw new Error(`createLineShape invalid x0 ${x0}`);
  }
  if (isNaN(Number(x1))) {
    throw new Error(`createLineShape invalid x1 ${x1}`);
  }
  if (isNaN(Number(y0))) {
    throw new Error(`createLineShape invalid y0 ${y0}`);
  }
  if (isNaN(Number(y1))) {
    throw new Error(`createLineShape invalid y1 ${y1}`);
  }
  /*

  To draw lines using Ticker method in HTML with easeLJS:

  var myLine = new createjs.Shape();

  myLine.graphics.setStrokeStyle(4);
  myLine.graphics.beginStroke(color);
  myLine.graphics.moveTo(startX, startY);

  startY++;

  myLine.graphics.lineTo(startX, startY);
  myLine.graphics.endStroke();
   */
  const line = new createjs.Shape();
  line.graphics.setStrokeStyle(strokeStyle.toArray());
  line.graphics.beginStroke(color);
  line.graphics.moveTo(x0, y0);
  line.graphics.lineTo(x1, y1);
  line.graphics.endStroke();
  return line;
}

